import ApiService from "../ApiService";

const ProviderService = {
    getProviders() {
        return ApiService.customRequest({
            // url: `${ApiService.farmadomiciliosApiURL}/provider`
            url: `https://pdn-helpharma-p2h-back.azurewebsites.net/provider`
        })
    }
};

export default ProviderService;